import { useState } from 'react';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const AddModuleModal = ({ openModal, setOpenModal,id,fetchCourseContent }) => {
  const [contentName, setContentName] = useState('');
  const handleAdd = async() => {
    if (contentName.trim() === '') return;
      try {
      const res = await fetch(`${BASE_URL}/courses/module/create/`, {
  method: "POST", // ✅ specify POST
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_X_API_KEY
  },
  body: JSON.stringify({
    course: id, 
    title: contentName
  }),
});


        const data = await res.json();
        console.log(data)
        if (res.ok) {
           alert('Course Module Created Successfully')
           fetchCourseContent()
        } else {
          console.error("Profile fetch failed");
        }
      } catch (error) {
        console.error("Error fetching profile:", error.message);
      }
    setContentName('');
    setOpenModal(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      setOpenModal(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAdd();
    }
  };

  if (!openModal) return null;

  return (
    <div
  className={`fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 transition-all duration-300 ${
    openModal ? "opacity-100 visible" : "opacity-0 invisible"
  }`}
  onClick={handleOverlayClick}
>
  <div
    className={`bg-white rounded-2xl w-full max-w-lg shadow-xl border border-gray-100 transform transition-all duration-300 ${
      openModal ? "translate-y-0 scale-100" : "-translate-y-7 scale-95"
    }`}
    onClick={(e) => e.stopPropagation()}
  >
    {/* Modal Header */}
    <div className="p-6 border-b border-gray-100">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
          <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
          </svg>
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-gray-900">Add New Module</h2>
            <button
              className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
              onClick={() => setOpenModal(false)}
            >
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <p className="text-sm text-gray-500 mt-1">
            Create a new module for your course
          </p>
        </div>
      </div>
    </div>

    {/* Modal Content */}
    <div className="p-6">
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-semibold text-gray-700">
            Module Name
          </label>
        </div>
        <input
          type="text"
          placeholder="Enter module name..."
          value={contentName}
          onChange={(e) => setContentName(e.target.value)}
          onKeyPress={handleKeyPress}
          autoFocus
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
        />
      </div>
    </div>

    {/* Modal Actions */}
    <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
      <div className="flex items-center justify-end gap-3">
        <button
          className="px-5 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
          onClick={() => setOpenModal(false)}
        >
          Cancel
        </button>
        <button
          className={`px-5 py-2.5 rounded-xl font-medium flex items-center gap-2 transition-colors ${
            contentName.trim()
              ? "bg-[#0f6abf] text-white hover:bg-[#0a5ca8]"
              : "bg-gray-200 text-gray-400 cursor-not-allowed"
          }`}
          onClick={handleAdd}
          disabled={!contentName.trim()}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
          </svg>
          Add Module
        </button>
      </div>
    </div>
  </div>
</div>
  );
};

export default AddModuleModal;
